module.exports = __webpack_public_path__ + "static/media/BETA.b1961fea.svg";